import {
  SET_CODE_OF_CONDUCT,
  CODE_OF_CONDUCT_LOADER,
  DOWNLOAD_COUNT,
} from "../actionTypes";

const initialState = {
  loader: false,
  pageData: {},
};

const codeOfConductReducer = (state = initialState, action) => {
  switch (action.type) {
    case CODE_OF_CONDUCT_LOADER:
      return {
        ...state,
        loader: action.payload,
      };

    case SET_CODE_OF_CONDUCT:
      return {
        ...state,
        pageData: action.payload,
      };
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          pageData: {
            ...state.pageData,
            fileViewCount: (state.pageData?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          pageData: {
            ...state.pageData,
            downloadCount: (state.pageData?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default codeOfConductReducer;
